/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { memo } from "react";

import ApplicationHeader from "application/components/ApplicationHeader";

const useClasses = makeStyles(() => ({
    appContainer: {
        backgroundColor: "#F7F8FA",
        minHeight: "100vh",
    },
}));

interface RequireAuthenticationProps {
    isAuthenticated: boolean;
}

function RequireAuthentication({ isAuthenticated }: RequireAuthenticationProps) {
    const classes = useClasses();
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return (
        <Grid
            className={classes.appContainer}
            container
            direction="column"
            justifyContent="flex-start"
        >
            <ApplicationHeader />
            <Outlet />
        </Grid>
    );
}

export default memo(RequireAuthentication);
